import {
  VerificationCriteriaResponse,
  VerificationCriteriaListResponse,
  CreateVerificationCriteriaRequest,
  UpdateVerificationCriteriaRequest,
} from "@/backend/express/controllers/verificationCriteria/verificationCriteriaController";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class VerificationCriteriaFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAllByRequirementId(requirementId: string): Promise<VerificationCriteriaListResponse> {
    return this.client.read(`/api/verification-criteria/requirement/${requirementId}`);
  }

  create(data: CreateVerificationCriteriaRequest): Promise<VerificationCriteriaResponse> {
    return this.client.create('/api/verification-criteria', data);
  }

  update(data: UpdateVerificationCriteriaRequest): Promise<VerificationCriteriaResponse> {
    return this.client.update(`/api/verification-criteria/${data.id}`, data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/verification-criteria/${id}`);
  }
}
